// extracted by css-extract-rspack-plugin
export default {"cls1":"UpsellTestCard-cls1_ukb","cls2":"UpsellTestCard-cls2_nrT UpsellTestCard-cls1_ukb"};